module.exports = __webpack_public_path__ + "img/Picture23.8c4c227a.png";